import _exceptions from './exceptions';
import _periods from './periods';
import _locations from './locations';
import _teachers from './teachers';
import _groups from './groups';
import _persons from './persons';
import _courses from './courses';
import _linkedEventsSets from './linked-events-sets';
import _lockedTimes from './locked-times';
import _rootIntervals from './root-intervals';
import _events from './events';
import _syllabuses from './syllabuses';
import _configurations from './configurations';
import _settings from './settings';
import type transform from '../to/schedules';

export default function (schedule: ReturnType<typeof transform>): Omit<ReturnType<typeof transform>, 'meta'> {
  return {
    ...schedule.settings         && { settings:         _settings        (schedule.settings         ) },
    ...schedule.periods          && { periods:          _periods         (schedule.periods          ) },
    ...schedule.groups           && { groups:           _groups          (schedule.groups           ) },
    ...schedule.teachers         && { teachers:         _teachers        (schedule.teachers         ) },
    ...schedule.persons          && { persons:          _persons         (schedule.persons          ) },
    ...schedule.locations        && { locations:        _locations       (schedule.locations        ) },
    ...schedule.courses          && { courses:          _courses         (schedule.courses          ) },
    ...schedule.events           && { events:           _events          (schedule.events           ) },
    ...schedule.linkedEventsSets && { linkedEventsSets: _linkedEventsSets(schedule.linkedEventsSets ) },
    ...schedule.lockedTimes      && { lockedTimes:      _lockedTimes     (schedule.lockedTimes      ) },
    ...schedule.rootIntervals    && { rootIntervals:    _rootIntervals   (schedule.rootIntervals    ) },
    ...schedule.exceptions       && { exceptions:       _exceptions      (schedule.exceptions       ) },
    ...schedule.syllabuses       && { syllabuses:       _syllabuses      (schedule.syllabuses       ) },
    ...schedule.configurations   && { configurations:   _configurations  (schedule.configurations   ) }
  };
}